import React from "react";
import { Provider } from "react-redux";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import ApolloRootProvider from "HOC/Apollo";
import { ThemeProvider } from "react-jss";
import { Router } from "Utils/router";
import { AnalyticsManager, onetrust } from "../shared/analyticsManager";
import Store from "../store";
import Routes from "../routes";
import theme from "../../theme";

Bugsnag.start({
  apiKey: `${process.env.REACT_APP_BUGSNAG_TAG}`,
  plugins: [new BugsnagPluginReact()],
  releaseStage: process.env.NODE_ENV,
  // disable for GDPR
  collectUserIp: false,
  redactedKeys: [/^userkey$/i, /^sessionid$/i, /^embed$/i, /^password$/i],
  autoTrackSessions: false, // Auto Track Session is off. It will be started manually after user gives Cookie Consent.
  onError: (event) => {
    if (!onetrust.hasAnalyticsCookiesConsent()) {
      // Remove generated anonymous ID (event.device.id) from report if user do not give consent for Analytics Cookies
      // eslint-disable-next-line no-param-reassign
      event.device.id = null;
      event.setUser("[REDACTED]");
      // eslint-disable-next-line no-param-reassign
      event.breadcrumbs = null;
    }
  },
});

const ErrorBoundary = Bugsnag.getPlugin("react").createErrorBoundary(React);

const store = Store({});
const App = () => {
  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <ApolloRootProvider>
            <Router>
              <AnalyticsManager />
              <Routes />
            </Router>
          </ApolloRootProvider>
        </Provider>
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default App;
